import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { monthSearchParam, weekSearchParam } from '@/features/timesheet/model/searchParams';
import { MonthView } from '@/features/timesheet/week/MonthView';
import { WeekPage } from '@/features/timesheet/week/WeekPage';

// `view=month` là xem tháng (chỉ đọc); vắng = xem tuần. Giá trị lạ coi như vắng.
const viewSearchParam = z.unknown().transform((v) => (v === 'month' ? ('month' as const) : undefined)).optional();

export const Route = createFileRoute('/_authenticated/attendance/')({
  validateSearch: z.object({ from: weekSearchParam, week: weekSearchParam, view: viewSearchParam, month: monthSearchParam, s: sortSearchParam }),
  component: function AttendanceWeek() {
    const { from, week, view, month, s } = Route.useSearch();
    return view === 'month' ? <MonthView month={month} s={s} /> : <WeekPage from={from} week={week} s={s} />;
  },
});
